import { createFileRoute } from "@tanstack/react-router";
import { ShipmentsPage } from "../../../workspaces/supply/pages/ShipmentsPage";
export const Route = createFileRoute("/_console/p/$org/$project/supply/shipments")({ component: ShipmentsPage });
